import { useTranslation } from "react-i18next";

import "modules/LocationReports/components/CustomLegend/CustomLegend.scss";
import { getTranslationOrValue } from "modules/LocationReports/utils";

import type { LegendProps } from "recharts";

export const CustomLegend = ({ payload }: LegendProps) => {
  const { t } = useTranslation();

  if (!payload?.length) return null;

  return (
    <ul className="CustomLegend">
      {payload.map((entry, index) => (
        <li key={index} className="list-item" style={{ color: entry.color }}>
          <svg width="14" height="14" viewBox="0 0 32 32" version="1.1">
            <rect width="32" height="24" fill={entry.color} rx="2" ry="2" x="0" y="5" />
          </svg>
          <span>{getTranslationOrValue(t, entry.value)}</span>
        </li>
      ))}
    </ul>
  );
};
